// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ql-size-small {\n  font-size: 0.75em;\n}\n.ql-size-large {\n  font-size: 1.5em;\n}\n.ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\nh1[class^=ql-] {\n  font-size: 2rem;\n  font-weight: 600;\n}\nh2[class^=ql-] {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\nh3[class^=ql-] {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
